import React, { Suspense } from 'react';

import { User } from '@repo/domain/user';
import { withEventScope } from '@repo/event-processor';
import { Button } from '@repo/ui/components/Buttons';
import CreateIcon from '@repo/ui/components/Icon/CreateIcon';

import ProfileWithSearchParams from 'components/HeadMenu/ProfileWithSearchParams';
import Notifications from 'components/Notifications/Notifications';
import { FlexRow } from 'styles/layouts';

import { newProjectButtonTheme } from './theme';

interface MobileHeaderUserActionsOldProps {
  user: User;
  onLogOut: () => void;
  onCreateNewDesign: () => Promise<void>;
}

const MobileHeaderUserActionsOld: React.FC<MobileHeaderUserActionsOldProps> = ({
  user,
  onLogOut,
  onCreateNewDesign,
}) => {
  return (
    <FlexRow alignItems="center" gap="14px" justifyContent="flex-end">
      <Button
        dataTestId="header--new-project"
        height="30px"
        icon={{ component: CreateIcon, height: '11px' }}
        label="New Project"
        name="mobileNewProjectButton"
        theme={newProjectButtonTheme}
        width="100px"
        onClick={onCreateNewDesign}
      />

      <Notifications forMobile />
      <Suspense>
        <ProfileWithSearchParams
          isSmall={true}
          user={user}
          onLogOut={onLogOut}
        />
      </Suspense>
    </FlexRow>
  );
};

export default withEventScope(MobileHeaderUserActionsOld, {
  module: 'mobileHeaderUserActions',
});
